import { createSlice, isRejected } from '@reduxjs/toolkit';
import { RootState } from '..';
import {
  removeAuthTokenToLocalStorage,
  removeAuthUserToLocalStorage,
} from '../../helper';
import { createTrial } from '../V2/TrialsSlice/api';

export interface IinitialState {
  visible: boolean;
  message: string;
}

const initialState: IinitialState = {
  visible: false,
  message: '',
};

export const ErrorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.visible = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isRejected, (state, action) => {
      // Skip error handling for createTrial 409 errors
      if (createTrial.rejected.match(action)) {
        const err = JSON.parse(action.error.message as string);
        if (err?.status === 409) {
          return;
        }
      }

      state.visible = true;
      state.message = 'Something went wrong';

      try {
        const err = JSON.parse(action.error.message as string);

        if (err.data) {
          if (err.data.error_description) {
            state.message = err.data.error_description;
          }
          if (err.data.message) {
            state.message = err.data.message;
          }
        }

        if (err.status === 401) {
          removeAuthTokenToLocalStorage();
          removeAuthUserToLocalStorage();
          window.location.href = process.env.PUBLIC_URL;
        }
      } catch (err) {
        if (action.error.message) {
          state.message = action.error.message;
        }
      }
    });
  },
});

export const { resetMessage } = ErrorSlice.actions;

export const getErrorState = (state: RootState): RootState['error'] =>
  state.error;

export default ErrorSlice.reducer;
